export default "__VITE_ASSET__BZrtz176__"